var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUrgent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "8 8 16 16",
    role: "presentation",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "ui-icon__outline",
    cx: 16,
    cy: 21.5,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    className: "ui-icon__outline",
    d: "M17.9806,11.2669l-0.9901,6.8805c-0.0781,0.5429-0.5847,0.9201-1.1315,0.8425c-0.4501-0.0638-0.7871-0.4171-0.8486-0.8425             l-0.9901-6.8805c-0.1562-1.0857,0.6036-2.0916,1.6972-2.2467s2.1067,0.5993,2.263,1.685             C18.0076,10.8931,18.0054,11.0879,17.9806,11.2669z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "ui-icon__filled",
    cx: 16,
    cy: 21.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "ui-icon__filled",
    d: "M18.4673,11.4246l-1.1419,6.9452c-0.121,0.7357-0.8122,1.2335-1.5438,1.1119c-0.5817-0.0967-1.0138-0.5581-1.1057-1.1119             l-1.1148-6.7802c-0.2157-1.3119,0.525-2.6778,1.8126-3.0092c1.4407-0.3708,2.8565,0.5807,3.0938,2.0239             C18.5126,10.88,18.5091,11.1632,18.4673,11.4246z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUrgent);
export default __webpack_public_path__ + "static/media/urgent.b899fb1d.svg";
export { ForwardRef as ReactComponent };